module.exports = {
      id: "comm-sports-usage",
      viewBox: "0 0 411.122 51.012",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-sports",
      toString: function () {
        return this.url;
      }
    }